import { Component, OnInit, AfterContentInit, ChangeDetectorRef, Inject, ViewChild, OnDestroy } from '@angular/core';
import { UserDataService } from '../services/user-data.service';
import { TextValue } from '../model/Common/TextValue';
import { TabDataService } from '../services/tab-data.service';
import { InboxService } from '../services/inbox.service';
import { DashboardService } from '../services/dashboard/dashboard.service';
import { MyViewsService } from '../services/myViews/my-views.service';
import { MyGroup } from "../model/LoginUserInfo/MyGroup";
import { NotificationService } from "../services/global-error/notification.service";
import { DOCUMENT } from "@angular/common";
import { QmaConstant } from "../constant/qma-constant";
import { RightNavigationService } from '../services/panel/panel.service';
import { SymphonyChatServiceService } from '../symphony/service/symphony-chat-service.service';
import { PiwikProUtils } from '../common/utility/piwikProUtils';
import { Subscription } from 'rxjs';
import { TabsComponent } from './tabs/tabs.component';

@Component({
  selector: 'app-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.scss'],
  // animations: [
  //   trigger('slideMenu', [
  //     transition(':enter', [
  //       style({ transform: 'translateX(100%)' }),
  //       animate('400ms ease-in', style({ transform: 'translateX(0%)' }))
  //     ]),
  //     transition(':leave', [
  //       animate('300ms ease-out', style({ transform: 'translateX(100%)' }))
  //     ])
  //   ])
  // ]
})
export class CoreComponent implements OnInit, OnDestroy, AfterContentInit {
  clickStatusArray: Array<boolean> = [false, false, false]; //Array to maintain the status of TopNav items(Notification, Help, User)
  advCriteriaToggle: boolean = true;
  loginUserInfo: boolean = false;
  sideBarStyle: any = 'right-panel';
  displayOverlay: boolean = false;
  menuStatusArray: any;
  isDashboard: boolean = true;
  requestObj: { "groupList": TextValue[] } = { "groupList": [] }; // adv search click req object
  public fgsColor: string;
  showPopUp: boolean = false;
  showNoGroupPopup: boolean = false;
  clrSearchCriteria: boolean = false;
  showError: boolean = false;
  errorMessage: string = '';
  isMobile: boolean = false;
  streamId: String = '';
  @ViewChild(TabsComponent) child!: TabsComponent;
  // symphony change
  symphonyEnabled: boolean = false;
  newMsgIndexes: number[] = [];
  tabDataSubscription: Subscription;
  activeTab: string = '';
  inquiryReportTypes = QmaConstant.QMA_REPORT_TYPES;
  isMessageMenuPinned: boolean = false;

  @ViewChild('drawer') drawer: any;

  toggleOverlay(value: any) {
    this.displayOverlay = value;
  }

  toggleDrawer() {
    this.drawer.toggle();
    this.tabDataService.drawerStatusChanged.emit(this.drawer.opened); // Emit from the service
  }

  onDrawerClose() {
    if (!this.isMessageMenuPinned) {
      this.tabDataService.drawerStatusChanged.emit(false); // Emit from the service
    }
  }

  hideOverlay() {
    this.displayOverlay = false;
  }

  constructor(private userDataService: UserDataService,
    private tabDataService: TabDataService,
    private inboxService: InboxService,
    private dashboardService: DashboardService,
    private myViewService: MyViewsService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private rightNavigationService: RightNavigationService,
    @Inject(DOCUMENT) private document,
    private symphonyChatService: SymphonyChatServiceService
  ) {
    /*C153176-4795 Mobile change */
    this.isMobile = (window.innerWidth <= QmaConstant.MOBILE_WIDTH);
    if (!this.isMobile) {
      // C153176-5105: comment unnecessary calls
      //this.dashboardService.getInquiriesTrendCnts();//AppUtils.formatDate()
      this.dashboardService.getIntensityHeatMapCnts();
      //this.dashboardService.getmailBoxStats();  //C153176-5677:Called twice
    }
    // C170665-663 | Making single call to endpoint getDashboardCounts
    // this.dashboardService.getDashboardCountsService();
    this.notificationService.getRErrorMessage().subscribe(data => {
      if (data) {
        this.showError = true;
        this.errorMessage = data.detail;
      }
    });

    this.rightNavigationService.getNavStatus().subscribe(clickedIndex => {
      if (clickedIndex < 0) {
        this.clickStatusArray.fill(false);
      }
      else {
        this.clickStatusArray[clickedIndex] = true;
      }
    })
  }
  ngOnInit() {
    this.tabDataService.getMessageMenuPin().subscribe((isPinned) => {
      this.isMessageMenuPinned = isPinned;
    });
    this.tabDataService.getMessageMenuToggleData().subscribe((isToggled) => {
      if (this.isMessageMenuPinned && !this.drawer.opened && isToggled) {
        this.drawer.open();
      }
    });
    // symphony change
    // check symphony entitlement
    this.symphonyChatService.getSymphonyEntitlement().subscribe((entitlement: any) => {
      if (entitlement && entitlement.status && this.userDataService.loggedInUserInfo && this.userDataService.loggedInUserInfo.symphonyConfig
        && this.userDataService.loggedInUserInfo.symphonyConfig.symphonyEnabled && this.userDataService.loggedInUserInfo.isSymphonyEnabledForUser == 'Y') {
        this.symphonyEnabled = true;
        // if symphony enabled add boolean for top nav option
        this.clickStatusArray.push(false);
      }
      else {
        this.symphonyEnabled = false;
      }
    });
    this.inboxService.searchTabEvent.subscribe((event: any) => {
      if (!event || !event.action) {
        return;
      }
      if (event.action === 'close' && event.tab && (event.tab.startsWith('NEW MESSAGE[') && event.tab.indexOf(']') !== -1)) {
        this.updateNewMsgIndex(parseInt(event.tab.substring('NEW MESSAGE['.length, event.tab.indexOf(']'))));
      } else if (event.action === 'close' && event.tab && (event.tab.startsWith('NEW BUBBLE[') && event.tab.indexOf(']') !== -1)) {
        this.updateNewMsgIndex(parseInt(event.tab.substring('NEW BUBBLE['.length, event.tab.indexOf(']'))));
      }
    });
    this.tabDataSubscription = this.tabDataService
      .getTabData()
      .subscribe((data) => {
        this.drawer.close();
        this.activeTab = data.header;
      });
     this.tabDataSubscription = this.tabDataService
      .onTabChange()
      .subscribe((data) => {
         this.activeTab = data;
      });//when tab is changed, from tabs component, this will update the activetab, so that messages menu and new message button can be shown or hidden accordingly
  }

  ngOnDestroy() {
    if (this.tabDataSubscription) {
      this.tabDataSubscription.unsubscribe();
    }
    this.drawer.close();
  }

  ngAfterContentInit() {
    // get data from user data service
    this.userDataService.httpGetLoginUserInfo();
    this.userDataService.getServiceStatus().subscribe(status => {
      this.loginUserInfo = status;
      let loggedInUser = this.userDataService.loggedInUserInfo;
      if (loggedInUser) {
        // Check added to handle User not having any group roles-UI will display message to contact Group Admin
        this.validateGroupRoles(loggedInUser.myGroups);

        // Check for out of office
        if (loggedInUser.outOfOffice) {
          const outOfOfficeSettings = this.userDataService.loggedInUserInfo.outOfOfficeSettings;
          const startDate = new Date(outOfOfficeSettings.fromDate);
          const toDate = new Date(outOfOfficeSettings.toDate);
          const today = new Date();
          // C170665-3212 Display pop up when user is OOO within date range
          if (today >= startDate || today <= toDate) {
            this.showPopUp = true;
          }
        }
        PiwikProUtils.trackJsonDataForTab(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Tab", "Dasboard");
        PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Menu", "Dasboard", "Click", "Dashboard", 0);


        // For Performance inprovement. Call dashboard count service on event instaed of every interval.
        this.dashboardService.getDashboardCountsEvent();
        this.cdr.detectChanges();
      }

    });
  }

  selectedMenuItem(_evt: any) {
    this.menuStatusArray = _evt;
  }

  handleViewRequestEvent(options) {
  }

  /**
   * Method to close OOO Confirm Popup
   */
  onCancel(): void {
    this.showPopUp = false;
  }

  /**
   * Method to reset the OOO setting
   */
  onConfirm(): void {
    this.userDataService.resetOutOfOffice().subscribe(result => {
      if (result.processingstatus) {
        this.showPopUp = false;

        // C153176-6103 : Update the changes on success.
        let loggedInUser = { ...this.userDataService.loggedInUserInfo };
        let outOfOfficeSettings = { ...loggedInUser.outOfOfficeSettings };
        outOfOfficeSettings.outOfOffice = false;
        loggedInUser.outOfOffice = false;
        loggedInUser.outOfOfficeSettings = outOfOfficeSettings;
        loggedInUser.outOfOfficeSettings.fromDate = null;
        loggedInUser.outOfOfficeSettings.toDate = null;
        this.userDataService.setLoginUserInfo(loggedInUser);
      }
    }, error => {
      throw new Error("Failed to reset Out of office setting");
    });
  }

  /**
   * Method to validate the group roles assigned to user.
   * @param myGroups : Groups
   */
  validateGroupRoles(myGroups: MyGroup[]): void {
    if (myGroups === undefined || myGroups === null || myGroups.length === 0) {
      this.showNoGroupPopup = true;
    }
  }

  /**
   * Method to close popup.
   */
  onCloseGroupPopup(): void {
    this.showNoGroupPopup = false;
    this.showError = false;
  }

  /**
   * Method to clear the search criteria on tab close.
   */
  clrSearchOnTabClose(event: any): void {
    this.clrSearchCriteria = event;
  }

  mailSupport() {
    const origin = this.document.location.origin;
    if (origin.indexOf('qa') >= 0 || origin.indexOf('uat') >= 0)
      window.location.href = "XXXX" + this.errorMessage;
    else if (origin.indexOf('prod') >= 0)
      window.location.href = "XXXX" + this.errorMessage;
    else
      window.location.href = "XXXX" + this.errorMessage;
  }

  openSymphonyChatView(streamId: String) {
    this.streamId = streamId;
  }

  closeChatView(event) {
    this.streamId = '';
  }
  openNewMessage(){
    let tabDataName = 'NEW MESSAGE';
    if(!this.isMobile){
      tabDataName = tabDataName + '[' + this.getNewMsgIndex() + ']';
    }
    let _symphonyData;
    this.tabDataService.sendTabData(tabDataName, 0, 'leftNav',_symphonyData);
  }
  getNewMsgIndex(): number {
    let index = this.newMsgIndexes.findIndex((e, i) => e === undefined);
    if (index === -1) {
      // no empty element found, push a new one at the end
      const v = this.newMsgIndexes.length +1;
      this.newMsgIndexes.push(v);
      return v;
    } else {
      // found empty slot, fill and return the value
      const v = index +1;
      this.newMsgIndexes[index] = v;
      return v;
    }
  }
  updateNewMsgIndex(removedIndex: number) {
    removedIndex--;
    if (removedIndex < 0 || removedIndex >= this.newMsgIndexes.length) {
      return;
    }
    this.newMsgIndexes[removedIndex] = undefined;
  }
  onOutsideClick(event: Event){
    const elementId = (event.target as HTMLElement).id;
    if(elementId !== 'sidePanelOpenButton'){
      this.child.onOutsideClick()
    }
  }
  isInquiryReport(type) {
   return this.inquiryReportTypes.includes(type);
  }
}
